import {
  GET_USER_GROUPS_FAIL,
  GET_USER_GROUPS_LIST,
  GET_USER_GROUPS_SUCCESS,
} from "src/constants/types";

export const userGroupsReducer = (state = {}, actions) => {
  switch (actions.type) {
    case GET_USER_GROUPS_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_USER_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        userGroups: actions.payload,
        error: "",
      };

    case GET_USER_GROUPS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
